export const WIDGET_TYPES_IDS = { 
    COMPUTE_EVENT: '38',
    TIME_BANK_BALANCE: '54'
}
